import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useCart } from "../cart";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Success = () => {
  const { clear } = useCart();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const r = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          clear();
          return;
        }
        if (r.data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (attempts.current >= 15) {
          setStatus("timeout");
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts.current >= 15) {
          setStatus("error");
          return;
        }
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 satin-bg" data-testid="checkout-success-page">
      <div className="text-center max-w-xl">
        {status === "checking" && (
          <>
            <h1 className="font-serif text-3xl md:text-4xl text-[#1A1612] mb-4">Verificăm starea plății...</h1>
            <div className="w-12 h-px bg-[#B8954C] mx-auto mt-8 animate-pulse" />
          </>
        )}
        {status === "paid" && (
          <>
            <p className="text-xs uppercase tracking-[0.4em] text-[#B8954C] mb-6">Mulțumim</p>
            <h1 className="font-serif text-4xl md:text-6xl font-light text-[#1A1612] mb-6" data-testid="success-title">
              Plată reușită
            </h1>
            <div className="sep-line max-w-xs mx-auto mb-8">
              <span className="diamond" />
            </div>
            <p className="text-[#6E665A] text-lg mb-12 font-light leading-relaxed">
              Mulțumim pentru comandă. Vei primi confirmarea pe email.
            </p>
            <Link to="/" className="btn-pill inline-flex" data-testid="success-back-button">
              Înapoi pe site
            </Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <h1 className="font-serif text-3xl md:text-4xl text-[#1A1612] mb-6" data-testid="success-error-title">
              Nu am putut verifica plata
            </h1>
            <p className="text-[#6E665A] mb-10 font-light">
              Comanda ta s-ar putea să fi fost procesată. Verifică emailul sau contactează-ne dacă suma a fost debitată.
            </p>
            <Link to="/" className="btn-pill inline-flex" data-testid="success-error-back">
              Înapoi pe site
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default Success;
